export const VERTEX = /* glsl */ `
  varying vec2 vUv;
  void main() {
    vUv = uv;
    gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
  }
`;
export const FRAGMENT = /* glsl */ `
  uniform float uProgress;
  uniform float uEdgeWidth;
  uniform vec3 uEdgeColor;
  uniform vec3 uBaseColor;
  uniform float uNoiseScale;
  varying vec2 vUv;
  float hash21(vec2 p) {
    return fract(sin(dot(p, vec2(12.9898, 78.233))) * 43758.5453);
  }
  float valueNoise(vec2 p) {
    vec2 i = floor(p);
    vec2 f = fract(p);
    vec2 u = f * f * (3.0 - 2.0 * f);
    float a = hash21(i + vec2(0.0, 0.0));
    float b = hash21(i + vec2(1.0, 0.0));
    float c = hash21(i + vec2(0.0, 1.0));
    float d = hash21(i + vec2(1.0, 1.0));
    return mix(mix(a, b, u.x), mix(c, d, u.x), u.y);
  }
  void main() {
    float n = valueNoise(vUv * uNoiseScale);
    if (n < uProgress) discard;
    float edge = smoothstep(uProgress, uProgress + uEdgeWidth, n);
    gl_FragColor = vec4(mix(uEdgeColor, uBaseColor, edge), 1.0);
  }
`;
